// Estilos específicos de InventoryQueryTable (no están en Table.styles.ts)
import { styled } from '@mui/material/styles';
import { Box, Typography, Button } from '@mui/material';
import { spacing } from '../../../styles/theme';

// Re-exporta estilos comunes desde Table.styles.ts y mantiene estilos específicos
export {
  TableContainerStyled,
  StyledTableContainer,
  StyledTable,
  StyledTableHead,
  StyledTableRow,
  StyledTableCell,
  StyledTableHeadCell,
  StyledCheckbox,
  DisabledCheckbox,
  StatusChip,
  ViewButton,
  EmptyStateContainer,
  EmptyStateIcon,
  EmptyStateTitle,
  EmptyStateSubtitle,
} from '../../common/Table/Table.styles';

// Re-exportar estilos de paginación desde el componente común
export {
  PaginationContainer,
  PaginationInfo,
  PaginationText,
  PaginationControls,
  StyledFormControl,
  StyledSelect,
  PageButton,
  PageButton as CurrentPageButton,
  EllipsisButton,
} from '../../common/Pagination/Pagination.styles';

// Barra de selección (usada cuando hay items seleccionados)
export const SelectionBar = styled(Box)(({ theme }) => ({
  padding: `${spacing.xs} ${spacing.md}`,
  backgroundColor: theme.palette.background.paper,
  borderBottom: `1px solid ${theme.palette.divider}`,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}));

export const SelectionText = styled(Typography)(({ theme }) => ({
  fontSize: '0.875rem',
  color: theme.palette.text.secondary,
  fontWeight: 500,
}));

// Botón de transferencia con degradado verde
export const TransferButton = styled(Button)(({ theme }) => ({
  minWidth: 120,
  borderRadius: spacing.md,
  textTransform: 'none',
  fontWeight: 600,
  padding: `${spacing.xs} ${spacing.md}`,
  transition: 'all 0.2s ease-in-out',
  background: 'linear-gradient(to right, #06b6d4, #10b981)',
  color: theme.palette.common.white,
  '&:hover': {
    background: 'linear-gradient(to right, #0891b2, #059669)',
    transform: 'translateY(-2px)',
    boxShadow: '0 8px 25px rgba(0, 0, 0, 0.15)',
  },
}));

// Nota: Los estilos de paginación (PaginationContainer, PaginationInfo, etc.)
// ya no se usan aquí porque la paginación está en CommonPagination.
// Se mantienen por compatibilidad pero pueden eliminarse en el futuro.
